import { gsap } from "gsap"
import { ScrollTrigger } from "gsap/ScrollTrigger"
import {
  deviceStateManager,
  garmentJacket,
  garments,
  garmentTShirt,
  overlay,
  scene,
} from "./Experience"

export class GarmentManager {
  constructor() {
    this.youreInGoodCompanyContainer = document.querySelector(
      ".youre-in-good-company"
    )
  }

  setGarmentAnimations() {
    //!Garment transitions

    this.tl = gsap.timeline()

    let scrubAmount = 0.5

    ScrollTrigger.defaults({
      immediateRender: false,
      ease: "power1.inOut",
    })

    //?Hoodie TBA
    //Animation on initial page load
    gsap.to(garments.hoodie.position, {
      x: 0,
      y: 0.14,
      z: 0.85,
      duration: 3,
      ease: "power1.inOut",
      onComplete: () => {
        document.querySelector("#html").style.overflow = "visible"
      },
    })
    gsap.to(garments.hoodie.rotation, {
      x: 0.18,
      y: 0,
      z: 0,
      duration: 4,
      ease: "power1.inOut",
    })

    this.tl.to(garments.hoodie.position, {
      y: 1.1,
      scrollTrigger: {
        trigger: ".youre-in-good-company",
        scrub: scrubAmount,
        start: "top bottom",
        end: "top top",
      },
    })

    //T-Shirt

    this.tl.to(garmentTShirt.tShirtGroup.rotation, {
      x: 0.2,
      y: 0,
      scrollTrigger: {
        trigger: ".scroll-area-1",
        scrub: scrubAmount,
        start: "top bottom",
        end: "center center",
      },
    })

    if (deviceStateManager.state === "mobile") {
      this.tl.to(garmentTShirt.tShirtGroup.position, {
        x: 0,
        y: 0.08,
        z: 0.6,
        scrollTrigger: {
          trigger: ".scroll-area-1",
          scrub: scrubAmount,
          start: "top bottom",
          end: "center center",
        },
      })
    } else {
      this.tl.to(garmentTShirt.tShirtGroup.position, {
        y: 0.08,
        z: 0.6,
        scrollTrigger: {
          trigger: ".scroll-area-1",
          scrub: scrubAmount,
          start: "top bottom",
          end: "center center",
        },
      })
    }

    this.tl.to(garmentTShirt.tShirtGroup.position, {
      y: 1.1,
      scrollTrigger: {
        trigger: ".what-is-augmented-fashion",
        scrub: scrubAmount,
        start: "top bottom",
        end: "top top",
      },
    })

    //Jacket
    this.tl.to(garmentJacket.jacketGroup.position, {
      x: 0,
      y: 0.1,
      z: 0.4,
      scrollTrigger: {
        trigger: ".what-is-augmented-fashion",
        scrub: scrubAmount,
        start: "bottom bottom",
        end: "bottom top",
      },
    })
    this.tl.to(garmentJacket.jacketGroup.rotation, {
      x: 0,
      y: -2.09,
      z: 0,
      scrollTrigger: {
        trigger: ".what-is-augmented-fashion",
        scrub: scrubAmount,
        start: "bottom bottom",
        end: "bottom top",
      },
    })

    this.tl.to(garmentJacket.jacketGroup.position, {
      x: 0.3,
      y: 0,
      z: 1.35,
      scrollTrigger: {
        trigger: ".scroll-area-2",
        scrub: scrubAmount,
        start: "10% top",
        end: "center center",
      },
    })
    this.tl.to(garmentJacket.jacketGroup.rotation, {
      x: 0.5,
      y: -2.28,
      z: 0,
      scrollTrigger: {
        trigger: ".scroll-area-2",
        scrub: scrubAmount,
        start: "10% top",
        end: "center center",
      },
    })

    // this.tl.to(garmentJacket.jacketGroup.position, {
    //   x: 0.3,
    //   y: 0,
    //   z: 1.35,
    //   scrollTrigger: {
    //     trigger: ".scroll-area-2",
    //     scrub: scrubAmount,
    //     start: "top bottom",
    //     end: "center center",
    //   },
    // })
    // this.tl.to(garmentJacket.jacketGroup.rotation, {
    //   x: 0.5,
    //   y: -2.28,
    //   z: 0,
    //   scrollTrigger: {
    //     trigger: ".scroll-area-2",
    //     scrub: scrubAmount,
    //     start: "top bottom",
    //     end: "center center",
    //   },
    // })

    // this.jacketGroup.position.set(0, -1.1, 0.4)
    // this.jacketGroup.rotation.set(0, -2.09, 0)

    this.tl.invalidate()
  }
}
